import courseManagePopup from './course/popup';

export default [...courseManagePopup];
